// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--iACda","price-row":"_02712f2b3b--price-row--shSeg","old-price":"_02712f2b3b--old-price--OxjPF","labels":"_02712f2b3b--labels--7fl_5"};